module.exports = __webpack_public_path__ + "media/images/flags/4x3/ind-e739b194b7ee0ae6c33ee5895f53233b.svg";